'use client';

import React from 'react';
import { motion } from 'motion/react';
import { type PropsWithChildren } from 'react';

export const AccordionArea = ({ children }: PropsWithChildren) => {
  return (
    <motion.div
      initial={{
        height: 0,
        zIndex: -1,
        opacity: 0,
      }}
      animate={{
        height: 'auto',
        zIndex: 1,
        opacity: 1,
      }}
      exit={{
        height: 0,
        zIndex: -1,
        opacity: 0,
      }}
      transition={{
        duration: 0.3,
        ease: 'easeOut',
      }}
      style={{ position: 'relative' }}
    >
      {children}
    </motion.div>
  );
};
